import dynamic from "next/dynamic";

const DiscussionSnippetV1 = dynamic(() => import("./V1"));
const DiscussionSnippetV2 = dynamic(() => import("./V2"));

type DiscussionSnippetProps = {
  discussion: any;
  parent?: any;
  onClick?: (_discussion: any, _e: React.MouseEvent) => void;
  onReply?: () => void;
  onDiscussionPost?: () => void;
  className?: string;
  noBorder?: boolean;
  hideActions?: boolean;
  hideSource?: boolean;
  showChildren?: boolean;
  isChildren?: boolean;
  showInlineComposer?: boolean;
  hideInlineReplyCta?: boolean;
  showComposerByDefault?: boolean;
  truncateBody?: number;
  customBodyClassName?: string;
  hideReply?: boolean;
  style?: "default" | "compact" | "v2" | "compactV2";
  showEditDelete?: boolean;
  hideSeeMore?: boolean;
  query?: string;
  clickAnywhere?: boolean;
  openModal?: boolean;
  hideLatestReply?: boolean;
  storeKey?: string;
  allowPollingInteraction?: boolean;
  showUpgradeLink?: boolean;
};
const DiscussionSnippet = ({
  style = "default",
  showEditDelete,
  ...props
}: DiscussionSnippetProps) => {
  if (style === "v2" || style === "compactV2") {
    return (
      <DiscussionSnippetV2
        {...props}
        compact={style === "compactV2"}
        showEditDelete={showEditDelete}
      />
    );
  }
  return <DiscussionSnippetV1 {...props} compact={style === "compact"} />;
};

export default DiscussionSnippet;
